import { createIcon } from '../shared'

const CommentIcon = createIcon(
  ({ color }) => (
    <path
      d="M1.75 10C1.75 5.58 5.334 2 9.755 2H14.121C18.611 2 22.25 5.64 22.25 10.13C22.25 13.09 20.643 15.81 18.054 17.24L10 21.7V18.01H9.933C5.443 18.11 1.75 14.5 1.75 10ZM9.755 4C6.438 4 3.75 6.69 3.75 10C3.75 13.37 6.52 16.08 9.888 16.01L10.239 16H12V18.3L17.087 15.49C19.038 14.41 20.25 12.36 20.25 10.13C20.25 6.74 17.506 4 14.121 4H9.755Z"
      fill={color}
    />
  ),
  '0 0 24 24',
  'TwitterCommentIcon',
)

export { CommentIcon }
